import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const PageContainer = styled.div`
  ${tw`
    flex
    flex-col
    w-full
    h-full
    items-center
    overflow-x-hidden
  `}
`;

const ProfileContainer = styled.div`
  ${tw`w-full w-80 md:w-1/2 max-w-full min-w-0 box-border`}
`;

const UserInfoItemSkeleton = styled.div`
  ${tw`
    w-full
    mb-4 max-w-full min-w-0 box-border`}
`;

const LabelSkeleton = styled(Skeleton)`
  ${tw`
    h-4
    w-24
    mb-1
  `}
`;

const ValueSkeleton = styled(Skeleton)`
  ${tw`
    h-6
    w-48
  `}
`;

const ButtonSkeleton = styled(Skeleton)`
  ${tw`
    w-full
    h-10
    mt-4
    rounded-md
  `}
`;

const ProfilePageSkeleton: React.FC = () => {
  return (
    <PageContainer>
      <ProfileContainer>
        {/* Email */}
        <UserInfoItemSkeleton>
          <LabelSkeleton />
          <ValueSkeleton width="80%" />
        </UserInfoItemSkeleton>

        {/* Name */}
        <UserInfoItemSkeleton>
          <LabelSkeleton />
          <ValueSkeleton width="60%" />
        </UserInfoItemSkeleton>

        {/* Display Name */}
        <UserInfoItemSkeleton>
          <LabelSkeleton />
          <ValueSkeleton width="70%" />
        </UserInfoItemSkeleton>

        {/* Host Status */}
        <UserInfoItemSkeleton>
          <LabelSkeleton />
          <ValueSkeleton width="20%" />
        </UserInfoItemSkeleton>

        {/* Dealer Status */}
        <UserInfoItemSkeleton>
          <LabelSkeleton />
          <ValueSkeleton width="20%" />
        </UserInfoItemSkeleton>

        {/* Sign out button */}
        <ButtonSkeleton />

        {/* Edit Profile button */}
        <ButtonSkeleton />
      </ProfileContainer>
    </PageContainer>
  );
};

export default ProfilePageSkeleton;
